export const AgentApiURL: string = process.env.REACT_APP_AGENTAPIURL!;
export const AdminURL: string = process.env.REACT_APP_ADMINURL!;
export const AgentHotelUrl: string = process.env.REACT_APP_HOTELURL!;
export const Environment: string = process.env.REACT_APP_ENVIRONMENT!;
export const SeatmapUrl: string = process.env.REACT_APP_SEATMAPURL!;
export const IS_DEBUG: boolean = process.env.NODE_ENV === 'development';
// export const AppVersion: string = process.env.REACT_APP_VERSION!;